import type { RouteObject } from "react-router-dom";
import Layout from "../components/feature/Layout";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Category from "../pages/category/page";
import Detail from "../pages/detail/page";
import NewsList from "../pages/news/page";
import NewsDetail from "../pages/news-detail/page";
import SearchPage from "../pages/search/page";
import Favorites from "../pages/favorites/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/:type", element: <Category /> },
      { path: "detail/:id", element: <Detail /> },
      { path: "news", element: <NewsList /> },
      { path: "news/:id", element: <NewsDetail /> },
      { path: "search", element: <SearchPage /> },
      { path: "favorites", element: <Favorites /> },
      { path: "about", element: <About /> },
      { path: "contact", element: <Contact /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;